import React from "react";
import { ThemedLayout, ThemedTitle, ThemedSider } from "@refinedev/antd";
import { Header } from "./header";

export default function Layout({ children }: React.PropsWithChildren) {
  return (
    <ThemedLayout
      Header={Header}
      Sider={(props: any) => (
        <ThemedSider
          {...props}
          render={({ items, logout, collapsed }) => {
            // Фильтруем items - убираем Настройки
            const filteredItems = items.filter((item: any) =>
              item?.key !== "settings/response" &&
              item?.key !== "settings"
            );

            // Возвращаем только items без logout
            return <>{filteredItems}</>;
          }}
        />
      )}
      Title={(titleProps: any) => (
        <ThemedTitle
          {...titleProps}
          icon={<img src="/logo.png" alt="Art‑Visage" style={{ height: 32 }} />}
          text=""
        />
      )}
    >
      {children}
    </ThemedLayout>
  );
}
